import { TAction } from '../../../../../../shared/frontend/scripts/actions/types/action';

export type TSiteModerationListState = {
  isLoading: boolean;
  isLoaded: boolean;
  data: any[];
  total: number;
  page: number;
  pageSize: number;
  totalPages: number;
  ui: Record<string, any>;
  error?: unknown;
};

export type TSiteModerationBansState = {
  isLoading: boolean;
  isLoaded: boolean;
  data: any[];
  error?: unknown;
};

export type TSiteModerationState = {
  list: TSiteModerationListState;
  bans: TSiteModerationBansState;
  requestPending: boolean;
};

const getInitialState = (): TSiteModerationState => ({
  list: {
    isLoading: false,
    isLoaded: false,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
    totalPages: 0,
    ui: {},
    error: null
  },
  bans: {
    isLoading: false,
    isLoaded: false,
    data: [],
    error: null
  },
  requestPending: false
});

const FETCH_MODERATION_REPORT_LIST = 'SITE_MODERATION/FETCH_MODERATION_REPORT_LIST';
const UPDATE_MODERATION_REPORT = 'SITE_MODERATION/UPDATE_MODERATION_REPORT';
const BATCH_UPDATE_MODERATION_REPORTS = 'SITE_MODERATION/BATCH_UPDATE_MODERATION_REPORTS';
const SET_REQUEST_PENDING = 'SITE_MODERATION/SET_REQUEST_PENDING';
const UPDATE_MODERATION_REPORT_LIST = 'SITE_MODERATION/UPDATE_MODERATION_REPORT_LIST';
const RESET_MODERATION_REPORT_LIST = 'SITE_MODERATION/RESET_MODERATION_REPORT_LIST';
const UPDATE_SINGLE_REPORT_IN_LIST = 'SITE_MODERATION/UPDATE_SINGLE_REPORT_IN_LIST';
const FETCH_REPORTER_BANS = 'SITE_MODERATION/FETCH_REPORTER_BANS';
const UPDATE_REPORTER_BANS = 'SITE_MODERATION/UPDATE_REPORTER_BANS';
const BAN_REPORTER = 'SITE_MODERATION/BAN_REPORTER';
const UNBAN_REPORTER = 'SITE_MODERATION/UNBAN_REPORTER';

const fetchModerationReportList = (params: Record<string, any>) => ({
  type: FETCH_MODERATION_REPORT_LIST,
  payload: params
});

const updateModerationReport = (id: number, params: Record<string, any>) => ({
  type: UPDATE_MODERATION_REPORT,
  payload: { id, params }
});

const batchUpdateModerationReports = (ids: number[], params: Record<string, any>) => ({
  type: BATCH_UPDATE_MODERATION_REPORTS,
  payload: { ids, params }
});

const updateModerationReportList = (data: Partial<TSiteModerationListState>) => ({
  type: UPDATE_MODERATION_REPORT_LIST,
  payload: data
});

const resetModerationReportList = () => ({
  type: RESET_MODERATION_REPORT_LIST
});

const updateSingleReportInList = (report: any) => ({
  type: UPDATE_SINGLE_REPORT_IN_LIST,
  payload: report
});

const setRequestPending = (pending: boolean) => ({
  type: SET_REQUEST_PENDING,
  payload: pending
});

const fetchReporterBans = () => ({
  type: FETCH_REPORTER_BANS
});

const updateReporterBans = (data: Partial<TSiteModerationBansState>) => ({
  type: UPDATE_REPORTER_BANS,
  payload: data
});

const banReporter = (params: Record<string, any>) => ({
  type: BAN_REPORTER,
  payload: params
});

const unbanReporter = (banId: number) => ({
  type: UNBAN_REPORTER,
  payload: banId
});

export const actions = {
  fetchModerationReportList,
  updateModerationReport,
  batchUpdateModerationReports,
  updateModerationReportList,
  resetModerationReportList,
  updateSingleReportInList,
  setRequestPending,
  fetchReporterBans,
  updateReporterBans,
  banReporter,
  unbanReporter
};

export const actionTypes = {
  FETCH_MODERATION_REPORT_LIST,
  UPDATE_MODERATION_REPORT,
  BATCH_UPDATE_MODERATION_REPORTS,
  SET_REQUEST_PENDING,
  UPDATE_MODERATION_REPORT_LIST,
  RESET_MODERATION_REPORT_LIST,
  UPDATE_SINGLE_REPORT_IN_LIST,
  FETCH_REPORTER_BANS,
  UPDATE_REPORTER_BANS,
  BAN_REPORTER,
  UNBAN_REPORTER
};

export function reducer(state = getInitialState(), action: TAction<any>) {
  switch (action.type) {
    case RESET_MODERATION_REPORT_LIST:
      return {
        ...state,
        list: getInitialState().list
      };
    case UPDATE_MODERATION_REPORT_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          ...action.payload
        }
      };
    case UPDATE_SINGLE_REPORT_IN_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          data: state.list.data.map((r: any) => (r.id === action.payload.id ? action.payload : r))
        }
      };
    case SET_REQUEST_PENDING:
      return {
        ...state,
        requestPending: action.payload
      };
    case UPDATE_REPORTER_BANS:
      return {
        ...state,
        bans: {
          ...state.bans,
          ...action.payload
        }
      };
    default:
      return state;
  }
}
